// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2107) return "static/chunks/2107-8148bde62fde68a0.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","4316":"ad2866b8","4390":"d648eb28","9690":"8cc6faea"}[chunkId] || chunkId) + "." + {"501":"d13bf505216111a2","2082":"a9a30808723bb927","4316":"da7517a88118b074","4390":"d13577ce9403f845","5687":"03f3298520415951","6457":"2836474f9bc0af5c","9690":"3698d3586241d690","9839":"12c9392b4199081f"}[chunkId] + ".js";
};